import i18n from "lib/i18n";
import $ from "jquery";
import { template } from "lodash";
import LargeTooltipView from "views/large_tooltip_view";
/* eslint-disable
    consistent-return,
    constructor-super,
    func-names,
    max-len,
    no-constant-condition,
    no-eval,
    no-multi-assign,
    no-shadow,
    no-this-before-super,
    no-undef,
    no-underscore-dangle,
    no-unused-expressions,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let CommentFormattingHelpView;

export default CommentFormattingHelpView = (function () {
  CommentFormattingHelpView = class CommentFormattingHelpView extends LargeTooltipView {
    static initClass() {
      this.prototype.tagName = "form";
      this.prototype.className = "comment-formatting-help-view large-tooltip arrow-right";
      this.prototype.events =
        { "click .tabbed .tab": "_onTabClick" };

      this.prototype.template = template(`\
<h4 class="legacy"><%= i18n.t('comment.label.formatting_help') %></h4>
<p>
  <%= i18n.t('comment.label.allowed_formatting_options') %><br>
  <%= i18n.t('comment.label.markdown', {
      markdown: "<a href='http://daringfireball.net/projects/markdown/syntax' target='_blank'>Markdown</a>",
      interpolation: { escapeValue: false }
    })
  %>.
</p>

<nav class="tabbed tabbed-condensed">
  <a href="#basic" class="active tab"><%= i18n.t('comment.label.formatting_basic') %></a>
  <a href="#lists" class="tab"><%= i18n.t('comment.label.formatting_lists') %></a>
</nav>

<div id="comment-format-basic">
  <dl>
    <dt><strong><%= i18n.t('comment.label.formatting_basic_bold') %></strong></dt>
    <dd><code>**<%= i18n.t('comment.label.formatting_basic_text') %>**</code></dd>
    <dt><em><%= i18n.t('comment.label.formatting_basic_italic') %></em></dt>
    <dd><code>*<%= i18n.t('comment.label.formatting_basic_text') %>*</code></dd>
    <dt><%= i18n.t('comment.label.formatting_basic_quote') %></dt>
    <dd><code>&gt; <%= i18n.t('comment.label.formatting_basic_text') %></code></dd>
    <dt><%= i18n.t('comment.label.formatting_basic_link') %></dt>
    <dd><code>[<%= i18n.t('comment.label.formatting_basic_text') %>](http://website.com)</code></dd>
  </dl>
</div>

<div id="comment-format-lists">
  <dl>
    <dt>
      <ul>
        <li><%= i18n.t('comment.label.formatting_lists_item') %></li>
        <li><%= i18n.t('comment.label.formatting_lists_item') %></li>
      </ul>
    </dt>
    <dd>
      <code>* <%= i18n.t('comment.label.formatting_lists_item') %><br>* <%= i18n.t('comment.label.formatting_lists_item') %></code>
    </dd>
    <dt>
      <ol>
        <li><%= i18n.t('comment.label.formatting_lists_numbered_item') %></li>
        <li><%= i18n.t('comment.label.formatting_lists_numbered_item') %></li>
      </ol>
    </dt>
    <dd>
      <code>1. <%= i18n.t('comment.label.formatting_lists_numbered_item') %><br>2. <%= i18n.t('comment.label.formatting_lists_numbered_item') %></code>
    </dd>
  </dl>
</div>\
`, { imports: { i18n } });
    }

    initialize(options) {
      super.initialize(options);

      this._onTabClick = this._onTabClick.bind(this);

      return this.render();
    }

    render() {
      this.$el.html(this.template());

      return this.hide();
    }

    _onTabClick(event) {
      event.preventDefault();

      if (!$(event.target).is(".active")) {
        this.$(".tab").removeClass("active");
        $(event.target).addClass("active");
        $("#comment-format-basic").toggle();
        return $("#comment-format-lists").toggle();
      }
    }
  };
  CommentFormattingHelpView.initClass();
  return CommentFormattingHelpView;
}());
